import { theme } from '@frontend/theme';

export type PromoColorTheme = 'seaweed' | 'success' | 'tangerine' | 'indigo';

export const BorderColorMap: Record<PromoColorTheme, string> = {
  seaweed: theme.colors.secondary.seaweed50,
  success: theme.colors.success50,
  tangerine: theme.colors.tangerine40,
  indigo: theme.colors.indigo50,
};

export const BGColorMap: Record<PromoColorTheme, string> = {
  seaweed: theme.colors.secondary.seaweed5,
  success: theme.colors.success5,
  tangerine: theme.colors.tangerine5,
  indigo: theme.colors.indigo5,
};
